// libs
import React from 'react';

import { DateFormat, formatDate } from '@lyearn/core/utils/date/formatDate';
import { useTranslation } from '@lyearn/i18n';
import { BellOutline } from '@lyearn/icons';
import { cn } from '@lyearn/style';
// components
import { Box, Typography } from '@lyearn/ui';
// hooks
import { useContentDetails } from '@/components/ContentDetails/context';
// types
import { ContentDetailsItemProps } from '@/components/ContentDetails/types';

function DueDate(props: ContentDetailsItemProps) {
  const { className } = props;
  const { t } = useTranslation();
  const { content } = useContentDetails();

  if (!content.dueDate) {
    return null;
  }

  const dueDate = formatDate(content.dueDate, DateFormat.Date);

  return (
    <Box
      className={cn(
        'flex h-40 w-max items-center justify-center rounded-8 border border-border ps-8 pe-12 xs:flex-row xs:px-12',
        className,
      )}>
      <BellOutline className="me-8" fillColorToken="icon-secondary" height={20} width={20} />
      <Typography color="text-text-paragraph" variant="body-short-02">
        {t('Tasks.Due')}: {dueDate}
      </Typography>
    </Box>
  );
}

export default React.memo(DueDate);
